import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export interface GetMasterPayrollListOldServicesInterface {
  data: {
    id: number
    staff: {
      id: number
      name: string
    }
    role: string
    employee_status: string
    payroll_type: string
    amount: string
  }[]
  pagination: {
    number_of_elements: number
    page_index: number
  }
}

export interface GetPayrollDetailByUserIdOldServicesInterface {
  data: {
    id: string
    staff_id: string
    staff_name: string
    payroll: {
      id: string
      start_date: string
      end_date: string
      period: string
      payroll_type: string
      total_amount: string
    }[]
  }
  pagination: {
    number_of_elements: number
    page_index: number
  }
}

export interface PayrollQueryParamsOldInterface {
  sort: string
  direction: string
  pageSize: number
  pageIndex: number
  numberOfElements: number
}

export const getMasterPayrollListOld = (
  params: Pick<PayrollQueryParamsOldInterface, 'direction' | 'pageIndex' | 'pageSize' | 'sort'> & {
    search?: string
    locationId: number
    year: string
    month: string
    payrollType: string
  },
) =>
  axiosInstanceApiGateway.Get<GetMasterPayrollListOldServicesInterface, true>({
    url: 'staff-management/internal/:version/payroll/list',
    params,
    version: 'v1',
    convertRequest: true,
  })

export const getDetailPayrollByUserIdOldServices = (
  params: PayrollQueryParamsOldInterface & { staffId: string | number },
) =>
  axiosInstanceApiGateway.Get<GetPayrollDetailByUserIdOldServicesInterface, true>({
    url: 'staff-management/internal/:version/payroll/detail',
    params,
    version: 'v1',
    convertRequest: true,
  })

export const getMasterPayrollPayslipPdfOld = (params: { payrollId: string | number }) =>
  axiosInstanceApiGateway.Get<{ data: string }, true>({
    url: 'staff-management/internal/:version/payroll/pdf',
    params,
    version: 'v1',
    convertRequest: true,
  })

export const postPublishPayslipOld = (payload: unknown) =>
  axiosInstanceApiGateway.Post({
    url: 'staff-management/internal/:version/payroll/publish',
    version: 'v1',
    data: payload,
    convertRequest: true,
  })

export const getExportedPayrollExcelOld = (data: {
  locationId: string
  year: string
  month: string
  search?: string
  payoutType?: string
}) =>
  axiosInstanceApiGateway.Post<{ data: { file_url: string } }, true>({
    url: 'staff-management/internal/:version/payroll/export',
    data,
    version: 'v1',
    convertRequest: true,
  })
